export const get = {
    method: 'GET',
    paths: ['/api/search'],
    fields: {
        locationId: {
            type: 'mongoId',
        },
        kioskId: {
            type: 'mongoId',
        },
        orderId: {
            type: 'mongoId',
        },
        integrationIdentifier: {
            type: 'keyString',
        },
        crashlyticsUserId: {
            type: 'keyString',
        },
        serialNumber: {
            type: 'keyString',
        },
        username: {
            type: 'keyString',
        },
        shortCode: {
            type: 'keyString',
        },
        urlSlug: {
            type: 'keyString',
        },
    },
};
//# sourceMappingURL=search_get.js.map